import { render, staticRenderFns } from "./suitch-map-widget.vue?vue&type=template&id=42d67812&scoped=true&"
import script from "./suitch-map-widget.vue?vue&type=script&lang=js&"
export * from "./suitch-map-widget.vue?vue&type=script&lang=js&"
import style0 from "./suitch-map-widget.vue?vue&type=style&index=0&id=42d67812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d67812",
  null
  
)

export default component.exports